<template>
  <div class="offer">
    <div class="tab">
      <div class="tab_item" :class="[index == active && 'item_active']" v-for="item, index in tabList" :key="index"
        @click="tabActive(index)">
        {{ $t(item) }}
      </div>
    </div>
    <div class="c2c_field">
      <div class="label">{{ $t('交易金额') }}(INR)</div>
      <van-field v-model="form.amount" :placeholder="$t('交易金额')" />
    </div>
    <div class="c2c_field">
      <div class="label">{{ $t('收付款备注') }}</div>
      <van-field v-model="form.remark" :placeholder="$t('收付款备注')" />
    </div>
    <div class="c2c_field">
      <div class="label">{{ $t('交易密码') }}</div>
      <van-field v-model="form.paypass" :placeholder="$t('请输入交易密码')" />
    </div>
    <template v-if="active == 0">
      <div class="c2c_field">
        <div class="label">{{ $t('手续费') }}: {{ rate }} INR</div>
      </div>
      <div class="c2c_field">
        <div class="label">{{ $t('实际到账') }}: {{ _money }} INR</div>
      </div>
    </template>

    <div class="btn" :style="hasAllValuesLoose() ? {} : { opacity: .5 }" @click="submit">{{ $t('发布挂单') }}</div>
  </div>
</template>
<script>
import { Field, Toast } from "vant"
import { C2C_ORDER } from "@/api";
import { mapGetters } from 'vuex';
export default {
  components: {
    [Field.name]: Field,
    Toast
  },
  data() {
    return {
      tabList: ['买入余额', '卖出余额'],
      active: 0,
      form: {
        amount: '',
        paypass: '',
        remark: ''
      },
      c2cRate: {}
    }
  },
  created() {
    this.getNotice();
  },
  computed: {
    ...mapGetters(['userInfo']),
    rate() {
      if (!this.isNumberStr(this.form.amount)) return 0;
      return Number((Number(this.form.amount) * ((this.c2cRate.fee_rate - 0) / 100)).toFixed(4));
    },
    _money() {
      if (!this.isNumberStr(this.form.amount)) return 0;
      return Number(this.form.amount) - this.rate;
    }
  },
  methods: {
    getNotice() {
      this.$api.getNotice((res) => {
        this.c2cRate = res.c2c
      });
    },
    isNumberStr(s) {
      return /^-?(?:\d+|\d*\.\d+)$/.test(String(s).trim());
    },
    hasAllValuesLoose() {
      let obj = this.form;
      if (!obj || typeof obj !== 'object') return false;
      const keys = Object.keys(obj);
      if (keys.length === 0) return false;
      return keys.every(key => {
        const val = obj[key];
        if (typeof val === 'string') {
          return val.trim().length > 0;
        }
        if (Array.isArray(val)) {
          return val.length > 0;
        }
        if (typeof val === 'number') {
          return !isNaN(val);
        }
        return !!val;
      });
    },
    tabActive(index) {
      if (this.active == index) return;
      this.active = index;
    },
    async submit() {
      if (!this.hasAllValuesLoose()) return;
      if (this.userInfo.setpaypass != 1) return Toast(this.$t('请设置交易密码'));
      Toast.loading();
      try {
        const res = await C2C_ORDER({ ...this.form, side: this.active == 0 ? 'buy' : 'sell' });
        Toast.clear();
        Toast(res.msg);
        setTimeout(() => {
          this.$store.dispatch('getuserInfo');
          this.form = {
            amount: '',
            paypass: '',
            remark: ''
          }
        }, 500)
      } catch (error) {
        Toast.clear();
        error.msg && Toast(error.msg);
      }
    }
  },

}
</script>
<style lang="less" scoped>
.offer {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .tab {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;

    .tab_item {
      height: 38px;
      border: 1px solid rgba(15, 23, 42, .08);
      border-radius: 12px;
      background: #fff;
      color: #667085;
      font-size: 13px;
      font-weight: 900;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .item_active {
      border-color: #31e2a55c;
      background: #31e2a524;
      color: #31e2a5;
    }
  }

  .c2c_field {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .label {
      color: #566071;
      font-size: 12px;
      font-weight: 900;
    }

    :deep(.van-field) {
      line-height: 42px;
      padding: 0 12px;
      border: 1px solid rgba(15, 23, 42, .08);
      border-radius: 12px;
      background: #fff;
      color: #111827;
      font-size: 14px;
      outline: none;
    }
  }

  .btn {
    margin-top: 20px;
    height: 40px;
    border-radius: 10000px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background: linear-gradient(90deg, #8ff5d1, #31e2a5);
    box-shadow: 0 9px 20px #31e2a547;
    font-weight: 600;
  }
}
</style>